import React from 'react';
import { Link } from 'components/core/Link';

const DEFAULT_NAV_LINKS = {
	Amenity: [
		{
			label: '24 Hour Self Storage Near You',
			href: '/self-storage-near-me/24-hour/',
		},
		{
			label: 'Climate Controlled Self Storage Near You',
			href: '/self-storage-near-me/climate-controlled/',
		},
		{
			label: 'Drive Up Self Storage Near You',
			href: '/self-storage-near-me/drive-up/',
		},
		{
			label: 'Self Storage With Electricity Near You',
			href: '/self-storage-near-me/electricity/',
		},
		{
			label: 'Self Storage With Free Truck Rental Near You',
			href: '/self-storage-near-me/free-truck-rental/',
		},
	],
	Size: [
		{
			label: 'Mini Self Storage Near You',
			href: '/self-storage-near-me/mini/',
		},
		{
			label: 'Small Self Storage Near You',
			href: '/self-storage-near-me/small/',
		},
		{
			label: 'Medium Self Storage Near You',
			href: '/self-storage-near-me/medium/',
		},
		{
			label: 'Large Self Storage Near You',
			href: '/self-storage-near-me/large/',
		},
		{
			label: 'Self Storage Lockers Near You',
			href: '/self-storage-near-me/lockers/',
		},
	],
	Vehicle: [
		{
			label: 'Self Storage for Boats Near You',
			href: '/self-storage-near-me/boat/',
		},
		{
			label: 'Self Storage for Cars Near You',
			href: '/self-storage-near-me/car/',
		},
		{
			label: 'Self Storage for RVs Near You',
			href: '/self-storage-near-me/rv/',
		},
	],
};

const DefaultMenu = () => (
	<>
		{Object.keys(DEFAULT_NAV_LINKS).map((category) => (
			<div key={`${category}-column`} className="find-storage-column">
				<div className="find-storage-heading category">
					Find Self Storage Near You by {category}
				</div>
				{DEFAULT_NAV_LINKS[category].map((link) => (
					<Link
						key={link.href}
						className="menu-link category find-storage-link"
						href={link.href}
						rel="noopener noreferrer"
					>
						{link.label}
					</Link>
				))}
			</div>
		))}
	</>
);

export { DEFAULT_NAV_LINKS };
export default DefaultMenu;
